import React, { useState } from 'react';
import { Tabs } from 'antd';
import { BellOutlined, SafetyCertificateOutlined, TeamOutlined } from '@ant-design/icons';

import NotificationsPanel from './NotificationsPanel.jsx';
import RolesPanel from './RolesPanel.jsx';
import UsersPanel from './UsersPanel.jsx';

const TABS = [
    { key: 'users', icon: <TeamOutlined />, label: 'Users' },
    { key: 'roles', icon: <SafetyCertificateOutlined />, label: 'Roles' },
    // docs/notifications/implementation-guide.md 8.2: each notification on or off, emailed or not.
    { key: 'notifications', icon: <BellOutlined />, label: 'Notifications' }
];

const PANELS = { users: UsersPanel, roles: RolesPanel, notifications: NotificationsPanel };

/** Section tab from the second hash segment: `#userManagement/roles`. */
const sectionFromHash = () => {
    const key = window.location.hash.replace('#', '').split('/')[1];
    return TABS.some((tab) => tab.key === key) ? key : TABS[0].key;
};

/**
 * User Management (IP-78; docs/auth/console-identity-and-access.md section 10),
 * for holders of core.access.admin: the people, the roles they hold, and
 * the notifications - which roles receive each is set on the role (Roles),
 * and whether each is sent and emailed here (Notifications).
 */
const UserManagement = () => {
    const [section, setSection] = useState(sectionFromHash);
    return (
        <div className="workspace user-management">
            <Tabs
                className="workspace-tabs"
                activeKey={section}
                onChange={(key) => {
                    setSection(key);
                    window.location.hash = 'userManagement/' + key;
                }}
                items={TABS}
            />
            <div className="workspace-body">{React.createElement(PANELS[section] ?? UsersPanel)}</div>
        </div>
    );
};

export default UserManagement;
